const defaultProps = {
  variantMapping: {
    banner: 'div',
    h3: 'div',
    h4: 'div',
    h5: 'div',
    h6: 'div',
    hero: 'div',
    subtitle1: 'div',
    subtitle2: 'div'
  }
};
export default {
  defaultProps
};